module.exports = __webpack_public_path__ + "static/media/openHouse2025Jpg.b8c61dd1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/openHouse2025Jpg.jpg
// module id = 297
// module chunks = 0